import { useCallback } from 'react';
import { useClient } from 'urql';

import fetchQuery from '@/helper/data-op/fetchQuery';
import {
  LearningPathContentDocument,
  LearningPathContentQuery,
} from '@/modules/corporate/modules/path/graphql/queries/generated/learningPathContent';
import { isValidObjectId } from '@/utils/urql';

export default function usePathContent() {
  const client = useClient();

  const fetchPathContent = useCallback(
    async (pathId: string) => {
      if (!isValidObjectId(pathId)) return undefined;
      const { error, data } = await fetchQuery<LearningPathContentQuery>(
        client,
        LearningPathContentDocument,
        {
          filters: {
            id: pathId,
          },
        },
        {},
      );

      if (error) {
        return;
      }

      return data?.content;
    },
    [client],
  );

  return {
    fetchPathContent,
  };
}
